

//
// =RESPONSIVE VIDEO!
// --------------------------------------------------

const vid = document.getElementById('msdw-video-responsive');

function loadVideo() {
  var sm = window.matchMedia( "(min-width: 0px) and (max-width: 599px)" ), // Standard def (mp4, 640x360)
      md = window.matchMedia( "(min-width: 600px) and (max-width: 899px)" ), // Standard def (mp4, 960x540)
      lg = window.matchMedia( "(min-width: 900px) and (max-width: 1199px)" ), // High def (mp4, 1280x720)
      xl = window.matchMedia( "(min-width: 1200px) and (max-width: 99999px)" ); // High def 1080 (mp4, 1920x1080)

  sm.addEventListener("change", changeVideoSize);
  md.addEventListener("change", changeVideoSize);
  lg.addEventListener("change", changeVideoSize);
  xl.addEventListener("change", changeVideoSize);

  if      (sm.matches) { changeVideoSize('sm') }
  else if (md.matches) { changeVideoSize('md') }
  else if (lg.matches) { changeVideoSize('lg') }
  else if (xl.matches) { changeVideoSize('xl') }
}

function changeVideoSize(size){
  const videoSource = $("#msdw-video-responsive source");
  videoSource.attr("src", videoSource.attr("data-video-"+size));
  vid.autoplay = true;
  vid.load();
  // console.log(videoSource.attr("src"));
}

if (document.contains(vid)) {
  document.addEventListener('DOMContentLoaded', loadVideo);
  window.onresize = loadVideo;
  vid.onloadeddata = () => vid.classList.add('msdw-video-loaded');
}

// window.addEventListener('resize', () => vid.attr('hidden' = true));
//
// =PAUSE OUT-OF-VIEW VIDEO
// --------------------------------------------------

const videos = document.querySelectorAll("video");

const config = {
  rootMargin: '0px -100px',
  threshold: 0
}

const callback = (entries) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) {
      entry.target.pause();
      // alert('Exit video');
    } else {
      entry.target.play();
      // alert('Enter video');
    }
  });
}

const vidsObserver = new IntersectionObserver(callback, config);

videos.forEach(element => {
  vidsObserver.observe(element);
});
